import React from "react";
import Loader from "../Loader";


const ProceedButton = ({text, handleClick,disable, type, btnloading}) => {
    return (
      <div className="row justify-content-center">
        <div className="col-lg-5">
          <div className="text-center my-3">
            <button
              className="btn w-100 sparkle--button__green sparkle--button__shadow d-flex justify-content-center m-auto px-5 mt-4 btn-block"
              onClick={handleClick}
              disabled={disable}
              type={type}
            >
              {text}
              {btnloading && (
                <Loader width="30" color="#fff" display="inline-block" />
              )}
            </button>
          </div>
        </div>
      </div>
    )
}
export default ProceedButton